export default function registerBulkSelect(Alpine) {
  Alpine.data("bulkSelect", (allIds) => ({
    selectedIds: [],
    targetValue: "",
    allIds: allIds || [],

    toggleOne(id, checked) {
      const key = String(id);
      if (checked) {
        if (!this.selectedIds.includes(key)) this.selectedIds.push(key);
      } else {
        this.selectedIds = this.selectedIds.filter((x) => x !== key);
      }
    },

    toggleAll(checked) {
      this.selectedIds = checked ? this.allIds.map(String) : [];
    },

    isSelected(id) {
      return this.selectedIds.includes(String(id));
    },

    isAllSelected() {
      return this.allIds.length > 0 && this.selectedIds.length === this.allIds.length;
    },

    clear() {
      this.selectedIds = [];
      this.targetValue = "";
    }
  }));
}
